<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <UserInfo/>
        <div class="profile-btn-grid">
            <router-link to="/configurator_lite/projects" target="_blank"
                         class="modal-button profile-btn modal-button-auto-width hide-underline">
                Lite Версия
            </router-link>
            <router-link to="/configurator/projects" target="_blank" class="modal-button modal-button-auto-width profile-btn hide-underline">
                Pro Версия
            </router-link>
        </div>
        <div class="profile-btn-grid">
            <div class="modal-button modal-button-auto-width button-logout hide-underline" @click="logOut">
                Выйти из профиля
            </div>
        </div>
    </div>
</template>

<script>
import UserInfo from "../UserInfo";
import SVGModalClose from "../../SVG/SVGModalClose";

export default {
    name: "UserProfileAP",
    components: {
        UserInfo,
        SVGModalClose
    },
    methods: {
        logOut() {
            localStorage.token = '';
            this.$store.commit('profile/USER_AUTHORIZED', false);
            this.$router.push({name: 'liteProjects'}).catch(() => {});
        }
    }
}
</script>

<style scoped>
    .profile-btn-grid {
        display: grid;
        grid-template-columns: auto auto;
        margin: 30px;
    }

    .profile-btn {
        margin: 0 5px 5px 0;
    }

    .button-logout {
        margin: 0 5px 5px 0;
        background-color: #e4373a;
    }

    .button-logout:hover {
        background-color: #8a0a1f;
    }

    .no-right-margin {
        margin-right: 0 !important;
    }

    .hide-underline {
        text-decoration: none;
    }
</style>
